import 'jquery-ui-dist/jquery-ui';
import filters from '../components/filters';

export default class collectionPage {
   constructor() {
      this.sessionStorageSupported = this.detectSessionStorageSupport();
      this.layoutStorageKey = this.getLayoutStorageKey();
      this.storedLayout = this.getStoredLayout();
      this.historyNavigation = this.detectHistoryNavigation();
   }

   init() {
      console.log('collection page');

      window.filter = new filters();

      if (this.historyNavigation) {
         this.restoreProductOrder();
         $('html').addClass('coll-ok');
      }

      // Prevent fetching if collection template is "featured"
      if ($('.template-suffix-featured').length == 0) {
         this.loadOtherPages();
      } else {
         this.launch();
      }

      this.setSizes('#products .product-item');

      if (!isTouch) {
         $('.name img, .name-first, .name-last').draggable({
         });

         $('.product-item').draggable({
         });

         $('.ruler').draggable({
         });
      }

      $('button.view-wall').on('click', function (e) {
         e.preventDefault();
         $('.change-view.curr').removeClass('curr');
         $(this).addClass('curr');
         $('body').removeClass('ruler-out single');
         $('html').removeClass('snapper');
      });

      $('button.view-grid').on('click', function (e) {
         e.preventDefault();
         $('.change-view.curr').removeClass('curr');
         $(this).addClass('curr');
         $('body').addClass('ruler-out');
         $('body').removeClass('single');
         $('html').removeClass('snapper');
      });

      $('button.view-single').on('click', function (e) {
         e.preventDefault();
         $('.change-view.curr').removeClass('curr');
         $(this).addClass('curr');
         $('body').addClass('ruler-out single');
         $('html').addClass('snapper');
      });

      $('.product-load--inner').on('click', function (e) {
         if (e.target == this) {
            e.preventDefault();
            e.stopPropagation();
            console.log('close');
            // if(e.target == this) {
            $('.product-close').click();
            // }
         }
      });

      /*
      $('.product-item--link').on('click', function(e){
         e.preventDefault();
         // ajax load
         let href = $(this).attr('href');
         $('#product-load .product-load--inner').load(href+' .product', function(){
            $('html').addClass('product-open');
            $('#product-load').addClass('open');
            $('#product-load .product').addClass('in');
         });
      });
      */

      // bind close
      $('#product-load .product-close').on('click', function (e) {
         e.preventDefault();
         $('#product-load').removeClass('open');
         $('html').removeClass('product-open');
         setTimeout(function () {
            $('#product-load .product-load--inner').html('');
         }, 500);
      });
   }

   shuffle() {
      var ul = document.querySelector('#products.product-list');
      for (var i = ul.children.length; i >= 0; i--) {
         ul.appendChild(ul.children[Math.random() * i | 0]);
      }
   }

   shouldShuffleProducts() {
      return !this.historyNavigation;
   }

   shouldRandomizeLayout() {
      if (this.historyNavigation && this.hasStoredLayoutOffsets()) {
         return false;
      }

      return true;
   }

   detectHistoryNavigation() {
      const navType = this.getNavigationEntryType();
      if (navType === 'back_forward') {
         return true;
      }

      if (navType === 'reload') {
         return false;
      }

      if (this.hasStoredLayout() && this.isLikelyReturnFromInternalPage()) {
         return true;
      }

      return false;
   }

   setSizes(selector) {
      $(selector).find('img').each(function () {

         if (window.innerWidth >= 800) {
            $(this).css({
               width: (Math.min(80, this.dataset.width)) + 'vw',
               height: this.dataset.height + 'vw',
               minWidth: (Math.min(80, this.dataset.width)) + 'vw',
               minHeight: this.dataset.height + 'vw',
            });
         } else {
            $(this).css({
               width: '',
               height: '',
               minWidth: '',
               minHeight: '',
            });
         }
      }).on('load', function () {
         const tar = $(this).closest('.product-item');
         const self = this;
         setTimeout(() => {
            $(tar).addClass('loaded');
            $(self).attr('srcset', $(self).attr('data-srcset'));
         }, 100);
      }).each(function () {
         if (this.complete) $(this).trigger('load');
      });
      const allowRandomLayout = this.shouldRandomizeLayout();
      const storedOffsets = this.historyNavigation ? this.getStoredLayoutOffsets() : null;
      const offsetsToPersist = {};
      const self = this;
      $(selector).each(function () {
         const id = this.dataset.id;

         if (storedOffsets && storedOffsets[id]) {
            self.applyLayoutOffsets(this, storedOffsets[id]);
            return;
         }

         const shouldRandomizeThisItem = allowRandomLayout || !storedOffsets || !storedOffsets[id];

         if (!shouldRandomizeThisItem) {
            return;
         }

         const offsets = self.generateRandomOffsets();
         self.applyLayoutOffsets(this, offsets);
         if (id) {
            offsetsToPersist[id] = offsets;
         }
      });

      if (Object.keys(offsetsToPersist).length > 0) {
         this.persistLayoutOffsets(offsetsToPersist);
      }
   }

   launch() {
      // remove duplicates by data-id
      var seen = {};
      $('#products .product-item').each(function () {
         var txt = this.dataset.id;
         if (seen[txt])
            $(this).remove();
         else
            seen[txt] = true;
      });

      window.filter.checkFilters();
      // Preserve ordering when user navigates via browser history (back/forward)
      if (this.shouldShuffleProducts()) {
         this.shuffle();
         this.persistProductOrder();
      }
      setTimeout(() => {
         $('html').addClass('coll-ok');
      }, 10);

      setTimeout(() => {
         if (window.wishlist) {
            window.wishlist.binds();
         } else {
            setTimeout(() => {
               if (window.wishlist) {
                  window.wishlist.binds();
               }
            }, 1000);
         }
      }, 200);
   }

   loadOtherPages() {
      const t = this;
      // Get all pagination links
      const paginationLinks = document.querySelectorAll('.pagination .paginate-link');
      var paginationLinksCompleted = 0;
      const processedLinks = new Set();
      const sectionWrapper = document.querySelector('#products[data-section-id]') || document.querySelector('[data-section-id]');
      const sectionId = sectionWrapper ? sectionWrapper.getAttribute('data-section-id') : null;

      if (paginationLinks.length > 0) {
         // Iterate through each pagination link and load the content
         paginationLinks.forEach(function (link, index) {
            const url = link.getAttribute('href');
            if (!url || processedLinks.has(url)) {
               paginationLinksCompleted++;
               if (paginationLinksCompleted == paginationLinks.length) {
                  t.launch();
               }
               return;
            }

            processedLinks.add(url);

            const requestUrl = new URL(url, window.location.origin);
            if (sectionId) {
               requestUrl.searchParams.set('section_id', sectionId);
            }

            // Fetch the content from each paginated URL via AJAX
            fetch(requestUrl.toString())
               .then(response => response.text())
               .then(html => {
                  // Parse the returned HTML string to a DOM object
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');

                  // Get the product items from the fetched page
                  const newProducts = doc.querySelectorAll('.product-item');

                  t.setSizes(newProducts);

                  // Append each product item to the existing product list container
                  const productList = document.querySelector('#products');
                  newProducts.forEach(function (product) {
                     // if(product.dataset.category != curFilter && curFilter != 'all-products') {
                     //    $(product).hide();
                     // }
                     let id = product.dataset.id;
                     // console.log(id);
                     if (!document.querySelector(`#products .product-item[data-id="${id}"]`)) {
                        productList.appendChild(product);
                     }
                  });

                  console.log('Page ' + (index + 2) + ' with ' + newProducts.length + ' products loaded successfully.');
                  paginationLinksCompleted++;
                  if (paginationLinksCompleted == paginationLinks.length) {
                     t.launch();
                  }
               })
               .catch(error => {
                  console.error('Error fetching paginated page:', error);
                  paginationLinksCompleted++;
                  if (paginationLinksCompleted == paginationLinks.length) {
                     t.launch();
                  }
               });
         });
      } else {
         this.launch();
      }
   }

   persistProductOrder() {
      const container = document.querySelector('#products.product-list');
      if (!container) {
         return;
      }

      const order = Array.from(container.children).map(item => item.dataset.id).filter(Boolean);
      if (order.length === 0) {
         return;
      }

      this.saveLayoutData({ order });
   }

   persistLayoutOffsets(offsets) {
      this.saveLayoutData({ margins: offsets });
   }

   applyLayoutOffsets(el, offsets) {
      const topValue = typeof offsets.top !== 'undefined' ? offsets.top : '';
      $(el).css({
         marginBottom: offsets.marginBottom || '',
         marginTop: offsets.marginTop || '',
         marginLeft: offsets.marginLeft || '',
         marginRight: offsets.marginRight || '',
         top: topValue
      });
   }

   generateRandomOffsets() {
      let margTop = Math.random() * 10 + 2 + 'rem';
      let topValue = '';

      if (window.innerWidth <= 800) {
         margTop = Math.random() * 4 + 'rem';
         topValue = margTop;
         margTop = 0;
      }

      return {
         marginBottom: Math.random() * 3 - 1.5 + 'rem',
         marginTop: margTop,
         marginLeft: Math.random() * 12 + 5 + '%',
         marginRight: Math.random() * 12 + 5 + '%',
         top: topValue
      };
   }

   restoreProductOrder() {
      const layout = this.storedLayout;
      if (!layout || !layout.order || !layout.order.length) {
         return;
      }

      const container = document.querySelector('#products.product-list');
      if (!container) {
         return;
      }

      const lookup = {};
      Array.from(container.children).forEach(item => {
         if (item.dataset.id) {
            lookup[item.dataset.id] = item;
         }
      });

      layout.order.forEach(id => {
         if (lookup[id]) {
            container.appendChild(lookup[id]);
         }
      });
   }

   getLayoutStorageKey() {
      return `collection-layout:${window.location.pathname}`;
   }

   detectSessionStorageSupport() {
      try {
         const testKey = '__collection_test__';
         window.sessionStorage.setItem(testKey, '1');
         window.sessionStorage.removeItem(testKey);
         return true;
      } catch (err) {
         return false;
      }
   }

   supportsSessionStorage() {
      return this.sessionStorageSupported;
   }

   getStoredLayout() {
      if (!this.supportsSessionStorage()) {
         return null;
      }

      try {
         const stored = window.sessionStorage.getItem(this.layoutStorageKey);
         return stored ? JSON.parse(stored) : null;
      } catch (err) {
         return null;
      }
   }

   saveLayoutData(partial) {
      if (!this.supportsSessionStorage()) {
         return;
      }

      const current = this.storedLayout || {};
      const mergedMargins = {
         ...(current.margins || {}),
         ...(partial.margins || {})
      };

      const merged = {
         ...current,
         ...partial,
         margins: Object.keys(mergedMargins).length ? mergedMargins : current.margins
      };

      this.storedLayout = merged;
      try {
         window.sessionStorage.setItem(this.layoutStorageKey, JSON.stringify(merged));
      } catch (err) {
         // swallow storage errors
      }
   }

   getStoredLayoutOffsets() {
      return this.storedLayout && this.storedLayout.margins ? this.storedLayout.margins : null;
   }

   hasStoredLayoutOffsets() {
      const offsets = this.getStoredLayoutOffsets();
      return offsets && Object.keys(offsets).length > 0;
   }

   hasStoredLayout() {
      return !!(this.storedLayout && Object.keys(this.storedLayout).length);
   }

   getNavigationEntryType() {
      if (window.performance) {
         if (typeof window.performance.getEntriesByType === 'function') {
            const navigationEntries = window.performance.getEntriesByType('navigation');
            if (navigationEntries && navigationEntries.length) {
               return navigationEntries[0].type;
            }
         }

         if (window.performance.navigation) {
            const nav = window.performance.navigation;
            switch (nav.type) {
               case nav.TYPE_RELOAD:
                  return 'reload';
               case nav.TYPE_BACK_FORWARD:
                  return 'back_forward';
               default:
                  return 'navigate';
            }
         }
      }

      return 'navigate';
   }

   isLikelyReturnFromInternalPage() {
      if (!document.referrer) {
         return false;
      }

      try {
         const refUrl = new URL(document.referrer);
         if (refUrl.origin !== window.location.origin) {
            return false;
         }

         return refUrl.pathname.indexOf('/products/') === 0 || refUrl.pathname === window.location.pathname;
      } catch (err) {
         return false;
      }
   }
}
